import { FAQ_DATA } from "@/components/shared/FAQ";
import type { PricingContent } from "../types";

export const EN_PRICING: PricingContent = {
  seoTitle: "Crayo Pricing | Plans for every creator",
  seoDescription:
    "Simple, transparent pricing for AI short-form video. Workflow credits, voiceovers, AI images, storage, and social tracking on every plan.",
  name: "Crayo Pricing",
  crumb: "Pricing",
  h1: "Pricing",
  subheading: "Every plan includes all Crayo tools. Pick how much you create.",
  faqs: [
    ...FAQ_DATA,
    {
      question: "How does Crayo compare to Opus Clip, CapCut and Submagic?",
      answer:
        "Crayo charges one workflow credit per finished video and includes every tool on every plan. Opus Clip meters by source minute uploaded, CapCut has no public pricing page, and Submagic caps credits, video count and minutes per video at once. The comparison hub lists dated, source-linked prices and features for each.",
      link: { href: "/compare", label: "See every comparison" },
    },
  ],
};
